var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g2, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _g3, _path31, _path32, _path33, _path34, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMily(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 125,
    viewBox: "0 0 83 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_334_1224)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7329 40.1285C16.8788 48.9011 17.8596 58.2676 22.5386 66.8513C19.4685 75.8365 17.218 85.3885 18.5549 94.7921C19.8918 104.196 25.4307 113.444 34.1942 117.011C41.3119 119.909 49.538 118.728 56.612 115.722C65.4561 111.966 73.343 105.049 76.4298 95.9191C80.034 85.2806 76.7657 73.6669 73.5042 62.9171C71.0757 54.9272 68.5061 46.6742 63.0343 40.3815C57.9222 34.5535 50.7644 30.9372 43.0585 30.2896C35.4505 29.6924 27.6308 32.1858 18.7329 40.1285Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_334_1224",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 30,
    width: 59,
    height: 89
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8096 40.1281C20.0495 48.9007 20.9799 58.2672 25.4171 66.8509C22.5049 75.8361 20.3787 85.3881 21.6416 94.7917C22.9046 104.195 28.158 113.444 36.4681 117.01C43.2163 119.908 51.0124 118.728 57.7236 115.721C66.121 111.966 73.5847 105.049 76.5338 95.9187C79.9533 85.2802 76.8697 73.6665 73.7593 62.9167C71.4584 54.9268 69.0232 46.6738 63.8336 40.3811C59.0706 34.5979 52.1209 30.8932 44.8958 30.2892C37.6706 29.6853 30.2372 32.1855 21.8096 40.1281Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_334_1224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.7661 29.1961C60.8169 27.2087 56.766 28.9835 54.24 31.504C51.7141 34.0244 49.823 37.3006 46.7697 39.1125C41.8186 42.0547 34.5935 40.6916 30.9826 45.2163C28.1275 48.7827 29.1721 54.0227 28.2954 58.5372C27.2273 63.9965 23.173 68.9969 24.0833 74.473C24.7551 78.5219 27.9864 81.5586 31.295 83.8969C34.6035 86.2351 38.2749 88.2157 40.7001 91.4919C44.1867 96.2157 44.4722 102.846 48.073 107.485C52.4027 113.059 60.8371 114.173 67.1082 111.099C73.3794 108.025 77.6151 101.567 79.5364 94.7277C81.4577 87.8884 81.2696 80.6409 80.7927 73.5553C80.2754 65.8792 79.3517 58.1593 76.8291 50.9117C74.3065 43.6642 71.9384 34.706 63.7661 29.1961Z",
    fill: "url(#paint0_linear_334_1224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.14 51.6234C78.0618 48.0469 74.2628 46.1405 70.7426 45.8875C67.2224 45.6344 63.6888 46.5825 60.145 46.7107C55.5063 46.8794 50.3671 45.7592 46.5782 48.6036C43.8608 50.6281 42.5777 54.6027 43.5551 57.9802C44.5326 61.3577 47.6665 63.895 50.9952 63.9928C53.1584 64.0536 55.4626 63.2134 57.4108 64.2189C59.2952 65.194 60.098 67.5188 61.2602 69.3745C64.5722 74.6617 72.1567 76.2408 77.1112 72.6811C82.0656 69.1215 82.1496 61.6006 79.14 51.6234Z",
    fill: "url(#paint1_linear_334_1224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5022 71.031C29.7498 69.5666 30.3409 67.6906 31.3486 66.4085C32.3563 65.1263 33.7234 64.2288 34.8487 63.0647C36.3266 61.5396 37.5661 59.4511 39.5882 59.0361C40.3304 58.9084 41.0938 59.0186 41.7702 59.3511C42.4467 59.6835 43.0018 60.2214 43.3569 60.8884C43.7096 61.5866 43.8532 62.3726 43.7704 63.1511C43.6875 63.9296 43.3817 64.6673 42.89 65.2748C42.2451 66.0306 41.2811 66.5535 40.9888 67.5253C40.6966 68.497 41.1635 69.4519 41.3651 70.4135C41.9495 73.1634 40.0987 76.2237 37.4989 76.8243C34.899 77.4249 32.5881 75.1204 30.5022 71.031Z",
    fill: "#D99E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5022 71.031C29.7498 69.5666 30.3409 67.6906 31.3486 66.4085C32.3563 65.1263 33.7234 64.2288 34.8487 63.0647C36.3266 61.5396 37.5661 59.4511 39.5882 59.0361C40.3304 58.9084 41.0938 59.0186 41.7702 59.3511C42.4467 59.6835 43.0018 60.2214 43.3569 60.8884C43.7096 61.5866 43.8532 62.3726 43.7704 63.1511C43.6875 63.9296 43.3817 64.6673 42.89 65.2748C42.2451 66.0306 41.2811 66.5535 40.9888 67.5253C40.6966 68.497 41.1635 69.4519 41.3651 70.4135C41.9495 73.1634 40.0987 76.2237 37.4989 76.8243C34.899 77.4249 32.5881 75.1204 30.5022 71.031Z",
    fill: "url(#paint2_linear_334_1224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6963 87.6424C75.9491 83.8263 70.0507 79.9427 63.4201 78.4345C61.0286 77.8913 58.5362 77.6517 56.3126 76.5687C54.7641 75.8129 53.3365 74.6454 51.6436 74.4329C49.7659 74.2 47.8177 75.3202 46.9243 77.0815C46.4913 77.9814 46.2975 78.9785 46.3616 79.976C46.4258 80.9734 46.7457 81.9372 47.2904 82.7736C49.4132 85.9385 54.0956 86.1814 56.195 89.3598C57.6394 91.5429 57.4378 94.4783 58.2977 96.9819C59.3054 99.914 61.781 102.117 64.5689 103.119C67.3568 104.121 70.4168 104.01 73.282 103.295C76.1472 102.58 78.8613 101.27 80.8699 99.0469C82.8786 96.8233 84.0442 93.6348 81.6963 87.6424Z",
    fill: "#E0AA7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6963 87.6424C75.9491 83.8263 70.0507 79.9427 63.4201 78.4345C61.0286 77.8913 58.5362 77.6517 56.3126 76.5687C54.7641 75.8129 53.3365 74.6454 51.6436 74.4329C49.7659 74.2 47.8177 75.3202 46.9243 77.0815C46.4913 77.9814 46.2975 78.9785 46.3616 79.976C46.4258 80.9734 46.7457 81.9372 47.2904 82.7736C49.4132 85.9385 54.0956 86.1814 56.195 89.3598C57.6394 91.5429 57.4378 94.4783 58.2977 96.9819C59.3054 99.914 61.781 102.117 64.5689 103.119C67.3568 104.121 70.4168 104.01 73.282 103.295C76.1472 102.58 78.8613 101.27 80.8699 99.0469C82.8786 96.8233 84.0442 93.6348 81.6963 87.6424Z",
    fill: "url(#paint3_linear_334_1224)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3818 13.4968L49.9347 2.84475C50.5326 2.16993 51.4194 1.4445 52.2188 1.85277C52.7966 2.14969 52.9578 2.89199 53.0485 3.53982C53.9628 10.2259 54.0958 16.9964 53.4448 23.7135C49.8239 19.7152 45.689 16.196 40.3818 13.4968Z",
    fill: "url(#paint4_linear_334_1224)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4727 13.6384C43.488 11.5262 46.1483 8.88771 48.4828 6.18506C48.6728 5.96027 48.9201 5.7916 49.1982 5.6971C49.4763 5.6026 49.7747 5.58582 50.0615 5.64858C50.8509 5.86452 51.0491 6.88012 51.1028 7.70003C51.3749 12.0863 51.6503 16.5334 50.908 20.859C48.5433 17.9067 45.4933 15.4942 41.4727 13.6384Z",
    fill: "url(#paint5_linear_334_1224)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9298 12.0727L18.6725 1.15748C18.0914 0.482664 17.2247 -0.283256 16.4152 0.104765C15.8308 0.384814 15.6494 1.11699 15.5419 1.76819C14.443 8.42911 14.1239 15.1963 14.5913 21.9318C18.3198 18.0111 22.5688 14.5965 27.9298 12.0727Z",
    fill: "url(#paint6_linear_334_1224)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.011 12.4064C23.1166 10.1896 20.5571 7.26089 18.3737 4.4334C18.0177 3.97452 17.1511 2.90156 16.5868 3.00616C15.962 3.12088 16.0728 5.53673 16.0023 6.35326C15.5858 11.0534 15.2096 14.2621 15.3036 18.9251C17.8262 16.0909 20.8963 14.0394 25.011 12.4064Z",
    fill: "url(#paint7_linear_334_1224)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3164 11.2422C21.3801 12.5311 15.821 14.3059 12.761 18.483C9.45245 23.0043 7.69572 28.8313 10.4098 34.24C19.9526 53.226 44.735 43.9473 48.5945 41.663C53.5456 38.7309 57.9055 26.5808 50.1933 18.6314C45.7595 14.0562 35.995 9.81494 28.3164 11.2422Z",
    fill: "#333333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3164 11.2422C21.3801 12.5311 15.821 14.3059 12.761 18.483C9.45245 23.0043 7.69572 28.8313 10.4098 34.24C19.9526 53.226 44.735 43.9473 48.5945 41.663C53.5456 38.7309 57.9055 26.5808 50.1933 18.6314C45.7595 14.0562 35.995 9.81494 28.3164 11.2422Z",
    fill: "url(#paint8_linear_334_1224)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_334_1224",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 10,
    width: 46,
    height: 36
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3164 11.2422C21.3801 12.5311 15.821 14.3059 12.761 18.483C9.45245 23.0043 7.69572 28.8313 10.4098 34.24C19.9526 53.226 44.735 43.9473 48.5945 41.663C53.5456 38.7309 57.9055 26.5808 50.1933 18.6314C45.7595 14.0562 35.995 9.81494 28.3164 11.2422Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_334_1224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7718 7.52455C21.3219 7.78394 21.8064 8.1649 22.1892 8.63894C22.5721 9.11298 22.8432 9.66782 22.9825 10.262C23.1217 10.8561 23.1254 11.4742 22.9933 12.07C22.8612 12.6658 22.5966 13.2239 22.2195 13.7025C21.0573 15.1702 18.9613 15.727 18.004 17.3533C17.3759 18.4127 17.3658 19.7152 17.1576 20.9264C16.7108 23.5211 15.2765 25.8796 13.409 27.732C11.5414 29.5844 9.26063 30.961 6.89256 32.0879C5.88487 32.5704 4.79321 33.0158 3.68475 32.8809C2.26391 32.7088 1.09499 31.5683 0.537405 30.2457C-0.0201835 28.923 -0.0571318 27.4317 0.0469961 25.9977C0.419841 20.8623 2.57293 15.8046 6.3081 12.2786C10.0433 8.75272 15.8576 5.2133 20.7718 7.52455Z",
    fill: "#D99E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7718 7.52455C21.3219 7.78394 21.8064 8.1649 22.1892 8.63894C22.5721 9.11298 22.8432 9.66782 22.9825 10.262C23.1217 10.8561 23.1254 11.4742 22.9933 12.07C22.8612 12.6658 22.5966 13.2239 22.2195 13.7025C21.0573 15.1702 18.9613 15.727 18.004 17.3533C17.3759 18.4127 17.3658 19.7152 17.1576 20.9264C16.7108 23.5211 15.2765 25.8796 13.409 27.732C11.5414 29.5844 9.26063 30.961 6.89256 32.0879C5.88487 32.5704 4.79321 33.0158 3.68475 32.8809C2.26391 32.7088 1.09499 31.5683 0.537405 30.2457C-0.0201835 28.923 -0.0571318 27.4317 0.0469961 25.9977C0.419841 20.8623 2.57293 15.8046 6.3081 12.2786C10.0433 8.75272 15.8576 5.2133 20.7718 7.52455Z",
    fill: "url(#paint9_linear_334_1224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8716 36.2718C23.0512 35.6886 23.3599 35.1538 23.7744 34.7073C24.1889 34.2609 24.6985 33.9144 25.2651 33.6937C25.8318 33.473 26.4408 33.3839 27.0465 33.4331C27.6523 33.4822 28.2391 33.6683 28.7632 33.9774C30.3721 34.9289 31.2253 36.9331 32.9451 37.6585C34.0771 38.1376 35.3602 37.9656 36.5862 37.9959C39.2096 38.0803 41.7321 39.1769 43.8181 40.7762C45.904 42.3755 47.5801 44.4539 49.0211 46.6539C49.6358 47.5885 50.227 48.6108 50.2471 49.731C50.274 51.1718 49.3167 52.4944 48.0873 53.2333C46.8579 53.9723 45.4001 54.2118 43.9692 54.3097C38.8535 54.6471 33.5564 53.2131 29.5727 49.9908C25.589 46.7686 21.2794 41.5016 22.8716 36.2718Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7149 8.60396C35.4976 10.318 36.3239 20.005 39.3436 18.6959C43.3744 7.91902 47.0994 14.8562 46.0615 23.6828C47.1062 28.3424 46.6191 27.6845 48.0769 29.4187C49.0073 30.5187 49.4474 33.0391 51.7986 31.315C54.1499 29.5908 59.6519 29.9316 60.6327 26.5238C61.6135 23.1159 60.1759 18.6891 57.304 15.0519C54.4321 11.4146 50.2871 8.54997 46.0246 6.83256C41.762 5.11515 33.9323 6.88992 34.7149 8.60396Z",
    fill: "#E8B185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7149 8.60396C35.4976 10.318 36.3239 20.005 39.3436 18.6959C43.3744 7.91902 47.0994 14.8562 46.0615 23.6828C47.1062 28.3424 46.6191 27.6845 48.0769 29.4187C49.0073 30.5187 49.4474 33.0391 51.7986 31.315C54.1499 29.5908 59.6519 29.9316 60.6327 26.5238C61.6135 23.1159 60.1759 18.6891 57.304 15.0519C54.4321 11.4146 50.2871 8.54997 46.0246 6.83256C41.762 5.11515 33.9323 6.88992 34.7149 8.60396Z",
    fill: "url(#paint10_linear_334_1224)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.392 33.582C50.0522 47.4158 26.741 47.3078 18.2529 42.8743",
    stroke: "#010101",
    strokeWidth: 0.409146,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4646 66.3112C23.0894 64.5905 23.7119 62.8685 24.3322 61.1455",
    stroke: "#010101",
    strokeWidth: 0.409146,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3511 25.0929C21.8261 28.1295 24.8089 31.9085 27.5599 32.7048C30.0825 33.4336 33.737 33.2919 35.9069 31.8107C38.0768 30.3294 39.2222 27.2422 38.0197 24.9005C37.2673 23.4395 35.7625 22.4847 34.1804 22.0629C32.5983 21.6412 30.9357 21.7019 29.3066 21.8369C28.104 21.9381 26.8713 22.0865 25.8032 22.6466C24.7683 23.2077 23.9168 24.0572 23.3511 25.0929Z",
    fill: "url(#paint11_linear_334_1224)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0619 27.5566C28.1717 29.5372 29.9419 32.0071 31.5677 32.5334C33.059 33.0159 35.2155 32.9316 36.4953 31.9699C37.775 31.0083 38.4401 28.9974 37.7246 27.4655C37.4959 27.0132 37.1754 26.6141 36.7837 26.2939C36.3921 25.9737 35.9379 25.7395 35.4506 25.6064C34.5094 25.3733 33.533 25.3195 32.572 25.4478C31.853 25.4723 31.148 25.6543 30.5062 25.9809C29.8838 26.3555 29.3823 26.9027 29.0619 27.5566Z",
    fill: "#D99E66"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0619 27.5566C28.1717 29.5372 29.9419 32.0071 31.5677 32.5334C33.059 33.0159 35.2155 32.9316 36.4953 31.9699C37.775 31.0083 38.4401 28.9974 37.7246 27.4655C37.4959 27.0132 37.1754 26.6141 36.7837 26.2939C36.3921 25.9737 35.9379 25.7395 35.4506 25.6064C34.5094 25.3733 33.533 25.3195 32.572 25.4478C31.853 25.4723 31.148 25.6543 30.5062 25.9809C29.8838 26.3555 29.3823 26.9027 29.0619 27.5566Z",
    fill: "url(#paint12_linear_334_1224)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4191 26.5576C30.5098 26.6588 30.3788 27.8364 30.4191 28.0793",
    stroke: "url(#paint13_linear_334_1224)",
    strokeWidth: 0.409146,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6731 30.2014C32.6386 29.3039 30.4049 28.0791 30.4049 28.0791C29.2033 28.6464 28.0753 29.3591 27.0459 30.2014",
    stroke: "url(#paint14_linear_334_1224)",
    strokeWidth: 0.409146,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9011 26.6213C29.9784 26.7212 30.0895 26.789 30.2133 26.8121C30.3372 26.8351 30.4651 26.8116 30.5729 26.7461C31.2447 26.3581 32.1415 25.4775 32.3263 24.5462C32.405 24.2776 32.3823 23.9893 32.2624 23.7364C32.1653 23.6031 32.0391 23.4937 31.8937 23.4165C31.7482 23.3394 31.5871 23.2965 31.4227 23.291C31.0868 23.2607 30.7711 23.3147 30.4452 23.3113C29.8641 23.3113 29.1655 23.1493 28.796 23.5542C28.7045 23.6706 28.643 23.8079 28.6173 23.9539C28.5915 24.0999 28.6021 24.2501 28.6482 24.391C28.7614 24.6745 28.9009 24.9468 29.0647 25.2042C29.2657 25.7187 29.5481 26.1973 29.9011 26.6213Z",
    fill: "url(#paint15_linear_334_1224)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7071 26.2746C29.865 26.3792 29.8348 25.6335 29.8247 25.3737C29.8586 25.111 29.8426 24.8443 29.7777 24.5875C29.7492 24.4981 29.6941 24.4197 29.6198 24.3627C29.5455 24.3057 29.4557 24.273 29.3623 24.269C29.2689 24.2649 29.1766 24.2898 29.0977 24.3401C29.0188 24.3904 28.9572 24.4638 28.9211 24.5504C28.8951 24.6023 28.8879 24.6617 28.9008 24.7184C28.9136 24.7751 28.9458 24.8254 28.9917 24.8608C29.0757 24.9081 29.1899 24.8608 29.2772 24.9182C29.3645 24.9756 29.4384 25.2151 29.4687 25.3366C29.5227 25.6552 29.6025 25.9689 29.7071 26.2746Z",
    fill: "#3A3A3A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5239 25.0427C31.6867 25.0282 31.8379 24.9523 31.9471 24.8301C31.9979 24.7677 32.0281 24.691 32.0335 24.6106C32.039 24.5302 32.0193 24.45 31.9773 24.3813C31.9115 24.305 31.8218 24.2534 31.7229 24.235C31.624 24.2166 31.5219 24.2325 31.4332 24.2801C31.2616 24.3808 31.1272 24.5347 31.0503 24.7187C30.8306 25.1731 30.7488 25.6824 30.8151 26.1831C30.8151 26.2472 30.8454 26.3282 30.9125 26.3451C30.9386 26.3488 30.9651 26.3439 30.9882 26.3311C31.0112 26.3184 31.0295 26.2984 31.0402 26.2742C31.0583 26.2246 31.0663 26.1718 31.0637 26.119C31.0862 25.717 31.2492 25.3359 31.5239 25.0427Z",
    fill: "#3A3A3A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1016 27.4816C40.6803 27.1441 42.2724 26.8371 43.8646 26.5672C45.4567 26.2972 47.0623 26.0712 48.6645 25.8519C50.2668 25.6325 51.8791 25.4706 53.488 25.3289L55.9065 25.1366C56.716 25.0927 57.5221 25.0387 58.3316 25.0117L53.5149 25.5853C51.9126 25.781 50.3071 25.9666 48.7082 26.1859C47.1093 26.4052 45.5071 26.6043 43.9049 26.8202L39.1016 27.4816Z",
    fill: "#DBDADA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7129 29.4056C40.8617 29.3246 42.0171 29.2976 43.1726 29.2942C44.3281 29.2909 45.4802 29.3178 46.6324 29.3685C47.7845 29.4191 48.9366 29.5034 50.0854 29.6215L51.8052 29.8105C52.3795 29.8914 52.9506 29.9623 53.5182 30.0601L46.6156 29.6924L39.7129 29.4056Z",
    fill: "#DBDADA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6426 31.4463C40.9459 31.6319 42.2391 31.8546 43.5356 32.0806C44.8322 32.3067 46.1187 32.5631 47.4119 32.8027C48.7051 33.0422 49.9882 33.3223 51.2713 33.6023L53.1994 34.0275C53.8376 34.1827 54.4791 34.3244 55.1173 34.4897C54.4657 34.3986 53.8174 34.2907 53.1658 34.1894L51.2209 33.852C49.9277 33.626 48.6379 33.3695 47.3447 33.13C46.0515 32.8904 44.7684 32.6104 43.4852 32.3303C42.2021 32.0503 40.9022 31.7668 39.6426 31.4463Z",
    fill: "#DBDADA"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6641 27.3812L16.1631 25.5727C14.6617 24.9755 13.1635 24.3648 11.6554 23.7912C10.1472 23.2176 8.63231 22.6204 7.13421 22.04L2.59961 20.3125C3.37889 20.5352 4.14809 20.7849 4.92065 21.0244L7.22154 21.7971C8.74987 22.3268 10.2648 22.8971 11.7763 23.4842C13.2878 24.0712 14.7792 24.6921 16.2605 25.3433C17.7418 25.9945 19.2164 26.6558 20.6641 27.3812Z",
    fill: "#DBDADA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6095 29.1014L12.8378 27.7112L6.05273 26.3818C6.63048 26.4257 7.2015 26.4932 7.77588 26.5539L9.49232 26.7867C10.6344 26.9521 11.7697 27.1579 12.9017 27.3806C14.0336 27.6033 15.1622 27.8597 16.2808 28.1499C17.3993 28.44 18.5111 28.7403 19.6095 29.1014Z",
    fill: "#DBDADA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1999 31.0994C17.8832 31.0994 16.5699 31.069 15.2565 31.0285C13.9432 30.988 12.6298 30.9172 11.3165 30.8666C10.0031 30.816 8.69311 30.7181 7.38312 30.6236L5.41476 30.4785C4.75977 30.4144 4.10476 30.3672 3.45312 30.293C4.12492 30.293 4.76648 30.293 5.42484 30.3132L7.39655 30.3672C8.70991 30.4077 10.0199 30.4752 11.3333 30.5292C12.6466 30.5831 13.9566 30.6742 15.27 30.7687C16.5833 30.8632 17.89 30.9644 19.1999 31.0994Z",
    fill: "#DBDADA"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7467 21.1317C22.8529 21.4679 22.9183 21.8157 22.9415 22.1676C22.9785 23.281 22.4209 24.192 21.6953 24.2291C20.9698 24.2662 20.3518 23.3687 20.3114 22.2553C20.2996 21.9251 20.3439 21.5954 20.4424 21.2802C20.9732 19.5898 22.216 19.5898 22.7467 21.1317Z",
    fill: "url(#paint16_linear_334_1224)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M39.179 21.1317C39.0728 21.4679 39.0074 21.8157 38.9842 22.1676C38.9472 23.281 39.5048 24.192 40.2303 24.2291C40.9559 24.2662 41.5739 23.3687 41.6142 22.2553C41.6261 21.9251 41.5818 21.5954 41.4832 21.2802C40.9525 19.5898 39.7097 19.5898 39.179 21.1317Z",
    fill: "url(#paint17_linear_334_1224)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0902 102.357C63.2557 106.024 56.7192 108.717 49.8736 109.442C43.028 110.168 35.8634 108.767 30.1498 104.924C24.5302 101.132 20.4591 95.1125 14.3055 92.2783C11.8367 91.1412 8.54826 90.733 6.7109 92.7405C5.03142 94.5625 5.41098 97.444 6.23057 99.7789C8.96813 107.573 15.5215 113.657 23.0724 116.943C30.6234 120.229 39.0846 120.928 47.2805 120.216C52.2618 119.781 57.2532 118.826 61.7912 116.72C66.3292 114.615 66.9976 113.451 70.9141 108.572C71.7707 107.502 73.6517 101.756 73.6517 101.756C73.6517 101.756 71.6867 100.724 69.0902 102.357Z",
    fill: "#333333"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0902 102.357C63.2557 106.024 56.7192 108.717 49.8736 109.442C43.028 110.168 35.8634 108.767 30.1498 104.924C24.5302 101.132 20.4591 95.1125 14.3055 92.2783C11.8367 91.1412 8.54826 90.733 6.7109 92.7405C5.03142 94.5625 5.41098 97.444 6.23057 99.7789C8.96813 107.573 15.5215 113.657 23.0724 116.943C30.6234 120.229 39.0846 120.928 47.2805 120.216C52.2618 119.781 57.2532 118.826 61.7912 116.72C66.3292 114.615 66.9976 113.451 70.9141 108.572C71.7707 107.502 73.6517 101.756 73.6517 101.756C73.6517 101.756 71.6867 100.724 69.0902 102.357Z",
    fill: "url(#paint18_linear_334_1224)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_334_1224",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 91,
    width: 69,
    height: 30
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0902 102.357C63.2557 106.024 56.7192 108.717 49.8736 109.442C43.028 110.168 35.8634 108.767 30.1498 104.924C24.5302 101.132 20.4591 95.1125 14.3055 92.2783C11.8367 91.1412 8.54826 90.733 6.7109 92.7405C5.03142 94.5625 5.41098 97.444 6.23057 99.7789C8.96813 107.573 15.5215 113.657 23.0724 116.943C30.6234 120.229 39.0846 120.928 47.2805 120.216C52.2618 119.781 57.2532 118.826 61.7912 116.72C66.3292 114.615 66.9976 113.451 70.9141 108.572C71.7707 107.502 73.6517 101.756 73.6517 101.756C73.6517 101.756 71.6867 100.724 69.0902 102.357Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_334_1224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.793 114.148C16.8007 114.931 18.3827 114.486 19.3199 113.649C20.257 112.812 20.8012 111.658 21.6476 110.741C22.4941 109.823 23.9015 109.124 25.0906 109.627C26.0748 110.046 26.5417 111.122 27.4654 111.652C29.4438 112.758 32.5911 110.919 34.096 112.546C35.0869 113.619 34.4083 115.35 35.0869 116.618C36.3733 119.021 41.1968 117.995 42.3624 120.451C42.8931 121.568 42.2717 122.938 41.2338 123.694C40.1958 124.45 38.8422 124.706 37.5389 124.868C30.1089 125.684 22.175 123.009 15.793 114.148Z",
    fill: "#EAA66C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.793 114.148C16.8007 114.931 18.3827 114.486 19.3199 113.649C20.257 112.812 20.8012 111.658 21.6476 110.741C22.4941 109.823 23.9015 109.124 25.0906 109.627C26.0748 110.046 26.5417 111.122 27.4654 111.652C29.4438 112.758 32.5911 110.919 34.096 112.546C35.0869 113.619 34.4083 115.35 35.0869 116.618C36.3733 119.021 41.1968 117.995 42.3624 120.451C42.8931 121.568 42.2717 122.938 41.2338 123.694C40.1958 124.45 38.8422 124.706 37.5389 124.868C30.1089 125.684 22.175 123.009 15.793 114.148Z",
    fill: "url(#paint19_linear_334_1224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0553 91.9338C17.3585 92.2712 18.1949 93.6546 18.3259 95.0076C18.4569 96.3606 18.0135 97.7069 17.5063 98.9519C16.9991 100.197 16.4147 101.459 16.2299 102.805C16.0452 104.151 16.2669 105.65 15.6757 106.905C14.9636 108.403 13.1531 109.186 11.5173 108.96C9.88149 108.733 8.45057 107.637 7.51342 106.26C6.57627 104.884 6.07578 103.271 5.73653 101.644C5.09496 98.5707 5.01435 95.2033 6.54604 92.4669C8.07773 89.7306 10.3417 90.3683 16.0553 91.9338Z",
    fill: "#F3B687"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0553 91.9338C17.3585 92.2712 18.1949 93.6546 18.3259 95.0076C18.4569 96.3606 18.0135 97.7069 17.5063 98.9519C16.9991 100.197 16.4147 101.459 16.2299 102.805C16.0452 104.151 16.2669 105.65 15.6757 106.905C14.9636 108.403 13.1531 109.186 11.5173 108.96C9.88149 108.733 8.45057 107.637 7.51342 106.26C6.57627 104.884 6.07578 103.271 5.73653 101.644C5.09496 98.5707 5.01435 95.2033 6.54604 92.4669C8.07773 89.7306 10.3417 90.3683 16.0553 91.9338Z",
    fill: "url(#paint20_linear_334_1224)"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5464 105.687C52.5007 110.748 40.8552 110.812 31.7692 105.812C26.9558 103.163 22.9486 99.2827 19.0051 95.4531",
    stroke: "#010101",
    strokeWidth: 0.409146,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3346 34.3076C49.9982 48.1414 26.6837 48.0301 18.1956 43.5965",
    stroke: "#BD232C",
    strokeWidth: 1.63658,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 54.1851C25.9896 54.1851 27.1972 52.4116 27.1972 50.2239C27.1972 48.0362 25.9896 46.2627 24.5 46.2627C23.0103 46.2627 21.8027 48.0362 21.8027 50.2239C21.8027 52.4116 23.0103 54.1851 24.5 54.1851Z",
    fill: "#999999"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5002 52.8487C25.5316 52.8487 26.3677 51.622 26.3677 50.1089C26.3677 48.5958 25.5316 47.3691 24.5002 47.3691C23.4687 47.3691 22.6326 48.5958 22.6326 50.1089C22.6326 51.622 23.4687 52.8487 24.5002 52.8487Z",
    fill: "#B7B7B7"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.5885,
    cy: 21.0083,
    rx: 2.62658,
    ry: 4.20168,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.5886,
    cy: 20.4835,
    rx: 1.57595,
    ry: 2.62605,
    fill: "url(#paint21_radial_334_1224)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.538,
    cy: 18.9078,
    rx: 0.525316,
    ry: 1.05042,
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.399,
    cy: 22.0591,
    rx: 2.62658,
    ry: 4.20168,
    fill: "white"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.3992,
    cy: 21.5343,
    rx: 1.57595,
    ry: 2.62605,
    fill: "url(#paint22_radial_334_1224)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.3486,
    cy: 19.9586,
    rx: 0.525316,
    ry: 1.05042,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_334_1224",
    x1: 52.5313,
    y1: 28.3418,
    x2: 52.5313,
    y2: 112.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_334_1224",
    x1: 59.3602,
    y1: 23.6343,
    x2: 71.9629,
    y2: 78.7825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99E66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F2003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_334_1224",
    x1: 35.7695,
    y1: 52.3373,
    x2: 34.4752,
    y2: 84.8019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99E66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F2003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_334_1224",
    x1: 63.0374,
    y1: 57.2481,
    x2: 52.4763,
    y2: 109.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99E66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F2003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_334_1224",
    x1: 47.1161,
    y1: 1.73437,
    x2: 47.1161,
    y2: 23.7135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_334_1224",
    x1: 46.4295,
    y1: 5.61133,
    x2: 46.4295,
    y2: 20.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6B2BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C40F2D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_334_1224",
    x1: 21.1563,
    y1: 0,
    x2: 21.1563,
    y2: 21.9318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_334_1224",
    x1: 20.1501,
    y1: 2.99902,
    x2: 20.1501,
    y2: 18.9251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6B2BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C40F2D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_334_1224",
    x1: 31.5193,
    y1: 11.5541,
    x2: 30.9942,
    y2: 49.8944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_334_1224",
    x1: 9.49891,
    y1: -2.89457,
    x2: 10.8718,
    y2: 47.0859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99E66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F2003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_334_1224",
    x1: 44.6519,
    y1: 3.15107,
    x2: 65.6845,
    y2: 40.7684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99E66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F2003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_334_1224",
    x1: 28.4995,
    y1: 10.9998,
    x2: 30.7221,
    y2: 33.1328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232323"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_334_1224",
    x1: 32.5697,
    y1: 25.2104,
    x2: 38.0362,
    y2: 37.1484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99E66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F2003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_334_1224",
    x1: 30.4315,
    y1: 26.5576,
    x2: 30.4315,
    y2: 28.0793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8C8C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_334_1224",
    x1: 30.3595,
    y1: 28.0791,
    x2: 30.3595,
    y2: 30.2014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8C8C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_334_1224",
    x1: 29.9995,
    y1: 19.9998,
    x2: 30.9995,
    y2: 25.4998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#494949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0D0D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_334_1224",
    x1: 21.6264,
    y1: 19.9932,
    x2: 21.6264,
    y2: 24.2302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5D83E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C5C15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_334_1224",
    x1: 40.2993,
    y1: 19.9932,
    x2: 40.2993,
    y2: 24.2302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5D83E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C5C15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_334_1224",
    x1: 39.5924,
    y1: 91.3301,
    x2: 39.5924,
    y2: 120.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_334_1224",
    x1: 26.8023,
    y1: 103.696,
    x2: 29.8844,
    y2: 127.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99E66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F2003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_334_1224",
    x1: 10.6696,
    y1: 83.7631,
    x2: 18.8881,
    y2: 110.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99E66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F2003"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_334_1224",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.5886 17.8574) rotate(90) scale(5.2521 3.1519)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0260387,
    stopColor: "#6D8A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_334_1224",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.3992 18.9082) rotate(90) scale(5.2521 3.1519)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0260387,
    stopColor: "#6D8A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_334_1224"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83,
    height: 125,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMily);
export default __webpack_public_path__ + "static/media/mily.3099c735ac7ba9f09d2598b4fc7bfd8b.svg";
export { ForwardRef as ReactComponent };